var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.273 6.632V4.737a1.863 1.863 0 0 0-1.818-1.895h-2.728a2.73 2.73 0 1 0-5.455 0H4.545a1.863 1.863 0 0 0-1.818 1.895v1.895A2.783 2.783 0 0 0 0 9.474a2.783 2.783 0 0 0 2.727 2.842v3.789A1.863 1.863 0 0 0 4.545 18h10.91a1.863 1.863 0 0 0 1.818-1.895v-3.789A2.783 2.783 0 0 0 20 9.474a2.783 2.783 0 0 0-2.727-2.842zm-1.818 9.474H4.545V4.737h10.91zm-8.182-5.685A1.422 1.422 0 1 1 8.636 9a1.391 1.391 0 0 1-1.363 1.421zM14.091 9a1.365 1.365 0 1 1-1.364-1.421A1.391 1.391 0 0 1 14.091 9zm-7.727 3.316h7.273v1.895H6.364z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBot);
export default __webpack_public_path__ + "static/media/icon-bot.948f8cdd.svg";
export { ForwardRef as ReactComponent };